/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'

import { Paper, Typography, Grid } from '@material-ui/core'

import AppToolBar from '../fluid/Utilities/AppToolBar'
import queryString from 'query-string'

const styles = theme => ({

})

class Screen extends Component {
    state = {}

    componentWillMount () {
      console.log("Screen Props : ", this.props)
    }

    renderAppBar = () => {
        if (this.showAppBar()) {
          return (
            <AppToolBar></AppToolBar>
          )
        }
    }

    showAppBar = () => {
      let route = this.props.location.search

      if (route.includes('%')) {
        route = decodeURIComponent(route)
        console.log("Params at AppJS decoded : ", route)
      }

      let params = queryString.parse(route, {arrayFormat: 'bracket'})
      console.log("Params at AppJS :", params)
      if (params.showAppbar !== undefined) {
        if (JSON.parse(params.showAppbar)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }

    getParams = () => {
      let route = this.props.location.search
      console.log("Params at AppJS pre decoding : ", route)
      if (route.includes('%')) {
        route = decodeURIComponent(route)
        console.log("Params at AppJS decoded : ", route)
      }
      
      let params = queryString.parse(route, {arrayFormat: 'bracket'})
      console.log("Params at AppJS :", params)
      return params
    }

    render() {
        return (
            <Fragment>
                {/* <Paper 
                    square 
                    style = {{
                        width : '100%', 
                        height : '40px', 
                        padding : '5px',
                        paddingLeft: '10px',
                        display : 'flex',
                        flexDirection : 'row'
                    }}
                >
                    <Typography style = {{marginTop: 'auto', marginBottom : 'auto'}} align = 'left' variant = 'button'>{this.props.screen_name}</Typography>
                </Paper> */}
                {this.renderAppBar()}
                <div style = {{
                  width: '100%', 
                  height : this.showAppBar() ? 'calc(100vh - 50px)' : '100vh', 
                  overflow : 'auto'
                }} container>
                    {React.cloneElement(this.props.children, {...this.props, params : this.getParams()})}
                </div>
            </Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(Screen));